module.exports = __webpack_public_path__ + "static/media/rollkall_hover.81179c5e.svg";